import { call, put, takeLatest } from 'redux-saga/effects';
import {
  NEW_FILTER_CONTAS_RECEBER_CONCILIACAO,
  NEW_FILTER_CONTAS_RECEBER_CONCILIACAO_PENDING,
  NEW_FILTER_CONTAS_RECEBER_CONCILIACAO_SUCCESS,
  NEW_FILTER_CONTAS_RECEBER_CONCILIACAO_FAILURE,
} from '../../actionTypes';
import { conciliacaoBancariaService } from '../../service';
import { AlertError } from '@components/common/AlertToast';

function* sagaNewFilterContasReceber(action) {
  try {
    yield put({ type: NEW_FILTER_CONTAS_RECEBER_CONCILIACAO_PENDING });

    const { propriedadeId, dataInicio, dataFim, page = 0, size = 10, historico } = action.args || action;

    const response = yield call(
      conciliacaoBancariaService.buscarContasReceberPendentes,
      propriedadeId,
      dataInicio,
      dataFim,
      page,
      size,
      historico
    );

    yield put({
      type: NEW_FILTER_CONTAS_RECEBER_CONCILIACAO_SUCCESS,
      response: response.data || response,
      args: { propriedadeId, dataInicio, dataFim, page, rows: size, historico }
    });

  } catch (error) {
    yield put({
      type: NEW_FILTER_CONTAS_RECEBER_CONCILIACAO_FAILURE,
      error: error.message || 'Erro ao buscar contas a receber'
    });

    const errorMessage = error.response?.data?.message || error.message || 'Erro ao buscar contas a receber';
    AlertError(errorMessage);
  }
}

export default function* watchNewFilterContasReceber() {
  yield takeLatest(NEW_FILTER_CONTAS_RECEBER_CONCILIACAO, sagaNewFilterContasReceber);
}
